import jwtDecode from 'jwt-decode';

import { TokenDecoder } from '../../../application/protocols/token-decoder';

export class JWTTokenDecoder implements TokenDecoder {
  decode<T>(token: string): T {
    const decodedToken = jwtDecode<T>(token);
    return decodedToken;
  }
}
